import React from 'react';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { FileSignatureIcon } from 'components/icons';
import { t } from '@lingui/macro';
import { graphql, useFragment } from 'utils/graphClient';
import { useOpenItemViewer } from 'apps/TenantApp/screens/ItemViewer/useOpenItemViewer';
import { RequestSignaturesOption_node$key } from './__generated__/RequestSignaturesOption_node.graphql';
import { useFeatureFlag } from 'utils/sessionProvider';
import { REQUEST_SIGNATURE_PARAM } from 'utils/routes';

const nodeFragment = graphql`
  fragment RequestSignaturesOption_node on Node {
    __typename
    id
    ... on SignableInterface {
      canCreateSignatureEnvelope {
        value
      }
      signatureEnvelope {
        id
        status
      }
    }
  }
`;

interface RequestSignaturesOptionProps {
  node: RequestSignaturesOption_node$key;
}

export const RequestSignaturesOption = ({
  node,
}: RequestSignaturesOptionProps) => {
  const { id, canCreateSignatureEnvelope, signatureEnvelope } = useFragment(
    nodeFragment,
    node,
  );
  const { openItemViewer } = useOpenItemViewer();

  const isSignaturesEnabled = useFeatureFlag('FEATURE_SIGNATURES');
  const canCreateSignature = canCreateSignatureEnvelope?.value;
  const isSignatureActive = signatureEnvelope?.status === 'SIGNING';
  const isSignatureCompleted = signatureEnvelope?.status === 'COMPLETED';

  const showRequestSignaturesOption =
    isSignaturesEnabled &&
    canCreateSignature &&
    !isSignatureActive &&
    !isSignatureCompleted;

  if (!showRequestSignaturesOption) {
    return null;
  }

  function onOpen() {
    openItemViewer(id, { [REQUEST_SIGNATURE_PARAM]: '1' });
  }

  return (
    <OptionsMenuItem
      icon={<FileSignatureIcon />}
      onClick={onOpen}
    >
      {t`Request signatures`}
    </OptionsMenuItem>
  );
};
